var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05 Iconography/Navigation/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ASR-Finder_Required-Expertise_Selected",
    transform: "translate(-55.000000, -253.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-Forms/Complex-Text-Input/With-Icon/Default",
    transform: "translate(40.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-Iconography/Navigation/Search",
    transform: "translate(15.000000, 21.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53125,0 C11.6906445,0 15.0625,3.37185548 15.0625,7.53125 C15.0625,9.43118459 14.3589645,11.1667997 13.1981974,12.4917913 L17.9629284,17.2558216 L17.2558216,17.9629284 L12.4917913,13.1981974 C11.1667997,14.3589645 9.43118459,15.0625 7.53125,15.0625 C3.37185548,15.0625 0,11.6906445 0,7.53125 C0,3.37185548 3.37185548,0 7.53125,0 Z M7.53125,1 C3.92414023,1 1,3.92414023 1,7.53125 C1,11.1383598 3.92414023,14.0625 7.53125,14.0625 C11.1383598,14.0625 14.0625,11.1383598 14.0625,7.53125 C14.0625,3.92414023 11.1383598,1 7.53125,1 Z",
    id: "Search-Icon"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9823932c20bc73defd41d79e42fd7333.svg";
export { ForwardRef as ReactComponent };